import * as angular from "angular";
import { CredentialsManager } from "../../shared/credentials-manager";
import { UserDataProvider } from "../../data-provider/user.dp";
import { ToastUtils } from "../../helper/toast.helper";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { CampaignService } from "../../services/campaign.service";
import { Campaign } from "../../models/campaign.model";
import { User } from "../../models/user.model";
import { DialogUtils } from "../../helper/dialog.helper";
import { SubscriptionDataProvider } from "../../data-provider/subscription.dp";

let CreateCampaignComponent = {
    selector: "vcCreateCampaign",
    templateUrl: "/angular/components/campaign/create-campaign.component.html",
    bindings: {},
    controller: class CreateCampaignController {
        private planSelected: boolean = true;
        private plans: any = [];
        public selected_plan = { interval: "Monthly" };
        private campaign: Campaign;
        private saving: boolean = false;
        private cards_loading: boolean = true;
        private activeCampaign: Campaign;
        private card: any = {};
        private searchPath: any = {};
        private active_section: string = "section1";
        private user_created_campaigns: any = {};
        private user: User;
        private create_error: string = "";

        private $scope: any;
        private __env: any;
        private $http: any;
        private $window: any;
        private toast: ToastUtils;
        private dialog: DialogUtils;

        private campaignDataProvider: CampaignDataProvider;
        private subscriptionDataProvider: SubscriptionDataProvider;
        private credentialsManager: CredentialsManager;

        constructor(
            $scope: any,
            $http: any,
            $cookies: any,
            __env: any,
            $location: any,
            $window: any,
            ToastUtils: ToastUtils,
            DialogUtils: DialogUtils,
            CampaignDataProvider: CampaignDataProvider,
            CredentialsManager: CredentialsManager,
            CampaignService: CampaignService,
            SubscriptionDataProvider: SubscriptionDataProvider,
            UserDataProvider: UserDataProvider,
            ModelsUtils: any
        ) {
            if ($cookies.get("rfsn")) {
                $location.search("rfsn", $cookies.get("rfsn"));
            }
            this.campaign = ModelsUtils.campaign();
            this.activeCampaign = ModelsUtils.campaign();
            this.user = ModelsUtils.user();

            this.$scope = $scope;
            this.__env = __env;
            this.$http = $http;
            this.toast = ToastUtils;
            this.dialog = DialogUtils;
            this.$window = $window;

            this.campaignDataProvider = CampaignDataProvider;
            this.subscriptionDataProvider = SubscriptionDataProvider;
            this.credentialsManager = CredentialsManager;

            this.activeCampaign = CampaignDataProvider.activeCampaign;
            this.searchPath = $location.search();
            this.active_section = this.searchPath.tab
                ? this.searchPath.tab
                : "section1";
            this.user = UserDataProvider.getActiveUser();

            this.subscriptionDataProvider.getPlans().then((plans) => {
                this.plans = plans;
            });

            CampaignService.userCreated().then((response) => {
                const json = response["data"];
                if (json.success) {
                    this.user_created_campaigns = json.data;
                }
            });

            this.user.getCard().then(
                () => {
                    this.cards_loading = false;
                },
                () => {
                    this.cards_loading = false;
                }
            );
        }

        openSection(section) {
            if (!this.planSelected) this.planSelected = true;
            this.active_section = section;
        }

        openCreditCardModal($event, plan) {
            if (angular.isDefined(plan)) {
                this.subscriptionDataProvider.setupIntent().then((intent) => {
                    plan.intent = intent;
                    this.campaign.plan = plan;

                    this.planSelected = true;
                    const parentEl = angular.element(document.body);
                    this.dialog
                        .show({
                            parent: parentEl,
                            component: "vc-create-credit-card-modal",
                            targetEvent: $event,
                            scope: this.$scope,
                            locals: {
                                user: this.user,
                                plan: plan,
                                charge: false,
                            },
                            ariaLabel: "Update Card",
                        })
                        .then((card) => {
                            if (card) {
                                this.showCreateCampaignToast(
                                    "Payment Method Changed, Successfully changed your payment method."
                                );
                            }
                        });
                });
            } else {
                this.planSelected = false;
            }
        }

        showCreateCampaignToast(toastMessage: string, success: boolean = true) {
            let endToast = success
                ? this.toast.success(toastMessage)
                : this.toast.error(toastMessage);
            endToast.position("bottom left").hideDelay(3000);
        }

        changePlan(plan) {
            if (!plan) {
                this.selected_plan.interval = "Monthly";
            } else {
                this.selected_plan.interval = "Yearly";
            }
        }

        selectPlan(plan) {
            this.subscriptionDataProvider
                .paymentIntent(plan.cpid)
                .then((intent) => {
                    plan.intent = intent;
                    this.campaign.plan = plan;
                });
            this.active_section = "section3";
        }

        formValid(): boolean {
            return (
                this.campaign.campaignname &&
                this.campaign.campaignname.trim() != "" &&
                this.campaign.plan &&
                this.campaign.plan.cpid &&
                this.user.card &&
                this.user.card.last4
            );
        }

        createCampaign() {
            this.saving = true;
            this.create_error = "";
            const data = {
                campaignname: this.campaign.campaignname,
                plan: this.campaign.plan,
            };

            this.$http.post("/v2/campaign/create", data).then(
                (response) => {
                    const json = response["data"];
                    this.saving = false;

                    if (json.success) {
                        if (!this.__env.test) {
                            this.$window.ga("send", {
                                hitType: "event",
                                eventCategory: "signup",
                                eventAction: "completed",
                                eventLabel:
                                    "create campaign for existing customer",
                                eventValue: 1,
                            });
                        }
                        this.activeCampaign =
                            this.campaignDataProvider.setActiveCampaign(
                                json.campaign
                            );
                        this.activeCampaign.localInfo = {};
                        this.credentialsManager.redirect(
                            "create",
                            json.campaign.campaignid
                        );
                    } else {
                        if (angular.isDefined(json.error)) {
                            if (angular.isDefined(json.message)) {
                                this.create_error = json.message;
                            } else {
                                this.showCreateCampaignToast(
                                    "Create " +
                                        this.__env.strings.campaign +
                                        " failed, An error has occured, contact " +
                                        this.__env.support_email,
                                    false
                                );
                            }
                        } else {
                            this.showCreateCampaignToast(
                                "Create " +
                                    this.__env.strings.campaign +
                                    " failed, An error has occured, contact " +
                                    this.__env.support_email,
                                false
                            );
                        }
                    }
                },
                () => {
                    this.showCreateCampaignToast(
                        "Create " +
                            this.__env.strings.campaign +
                            " failed, An error has occured, contact " +
                            this.__env.support_email,
                        false
                    );
                }
            );
        }
    },
};

angular
    .module("campaign", ["LocalStorageModule"])
    .component(CreateCampaignComponent.selector, CreateCampaignComponent);
